import { deviceType, batteryLevel as batteryLevelConst } from "../constant";
import { shouldDisplayBatteryInfo } from "../_helperFunctions/shouldDisplayBatteryInfo";

export const batteryLevel = (car, getUserRole, siteSettingsData) => {
    if (car.UseVoltage && ![deviceType.VDU3, deviceType.VDU4].car?.DevType) return car.BatteryVoltage?.toFixed(1) + 'v';

    if (car.IsCharging || car.BatteryLevel > 100) return '';                  // don't show % when on charge or over 100

    if (!shouldDisplayBatteryInfo(getUserRole) && 
        siteSettingsData && 
        !siteSettingsData.ShowBatteryLevel && 
        (car.BatteryLevel > batteryLevelConst.warning)) return '';   // don't show % while green unless admin or site has permission to see them
    
    return car.BatteryLevel ? car.BatteryLevel.toString() + '%' : '0%';
};